// Helper function to set the variant id on the price row
(() => {
  function setVariantId(card, variantId) {
    const priceRow = card.querySelector(".price-row");
    if (priceRow && variantId) priceRow.setAttribute("data-variant-id", variantId);
  }

  function init() {
    document.querySelectorAll(".product-card").forEach((card) => {
      const activeVariantBtn = card.querySelector(".variant-btn.active");
      setVariantId(card, activeVariantBtn?.getAttribute("data-id"));

      card.querySelectorAll(".variant-btn").forEach((btn) => {
        if (btn.dataset.listenerAttached) return;
        btn.dataset.listenerAttached = "true";

        btn.addEventListener("click", function () {
          setVariantId(card, this.getAttribute("data-id"));

          if (window.Abra && typeof window.Abra.render === "function") {
            window.Abra.render();
          }
        });
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  const observer = new MutationObserver(() => init());
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();

// Race condition in the kaching cart fix
(() => {
    if (window.__raceConditionDetectorInstalled) return;
    window.__raceConditionDetectorInstalled = true;
  
    const DISCOUNT_PARAMS = ['abralink', 'discount', 'promo', 'code'];
    const STORAGE_KEY = '__abra_discount_code';
    const ATTEMPT_KEY = '__abra_discount_attempt_key';
    const DEBOUNCE_MS = 1200;
  
    let inProgress = false;
    let lastAttemptAt = 0;
  
    const safeGet = (storage, key) => {
      try { return storage.getItem(key); } catch (e) { return null; }
    };
    const safeSet = (storage, key, value) => {
      try { storage.setItem(key, value); } catch (e) {}
    };
    const safeJson = (text) => {
      try { return JSON.parse(text); } catch (e) { return null; }
    };
    const pickCode = (value) => {
      if (typeof value !== 'string') return null;
      const code = value.trim();
      return /^[A-Za-z0-9_-]{3,40}$/.test(code) ? code : null;
    };
  
    const isAbraActive = () => {
      const classes = Array.from(document.body?.classList || []);
      return classes.some((c) => /^abra--.+-(applied|activated)$/i.test(c));
    };
  
    const getCodeFromActivePromotion = () => {
      const raw = safeGet(localStorage, 'abra:active-promotion');
      const parsed = raw ? safeJson(raw) : null;
      const discountCodes = parsed?.promotion?.discountCodes;
      if (!Array.isArray(discountCodes)) return null;
      const preferred = discountCodes.map(pickCode).filter(Boolean).sort((a, b) => {
        const score = (v) => (/DISCOUNT|PROMO|SAVE|OFFER/i.test(v) ? 2 : 0) + (/^FIRST/i.test(v) ? -1 : 0);
        return score(b) - score(a);
      });
      return preferred[0] || null;
    };
  
    const getDiscountCode = () => {
      const params = new URLSearchParams(location.search);
      const fromUrl = DISCOUNT_PARAMS.reduce((acc, key) => acc || params.get(key), null);
      const urlCode = pickCode(fromUrl);
      if (urlCode) {
        safeSet(sessionStorage, STORAGE_KEY, urlCode);
        return urlCode;
      }
  
      const promoCode = getCodeFromActivePromotion();
      if (promoCode) {
        safeSet(sessionStorage, STORAGE_KEY, promoCode);
        return promoCode;
      }
  
      return pickCode(safeGet(sessionStorage, STORAGE_KEY));
    };
  
    const hasDiscount = (cart) =>
      !!(
        cart?.total_discount > 0 ||
        cart?.items?.some((i) => i?.discounts?.length > 0) ||
        (Array.isArray(cart?.discount_codes) && cart.discount_codes.length > 0) ||
        (Array.isArray(cart?.allCodeDiscounts) && cart.allCodeDiscounts.length > 0)
      );
  
    const syncKaching = async (code) => {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ discount: code }),
      }).catch(() => {});
  
      await fetch('/cart/update.js?kaching-cart=true', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ discount: code }),
      }).catch(() => {});
      try { await window.kachingCartApi?.refreshCart?.(); } catch (e) {}
      try { window.kachingCartApi?.updateTieredPromotionsBar?.(); } catch (e) {}
    };
  
    const emitCartUpdated = () => {
      if (typeof publish === 'function') publish('cart-update', { source: 'abra-kaching-sync' });
      document.dispatchEvent(new CustomEvent('cart:updated'));
    };
  
    const apply = async (code, attemptKey) => {
      const now = Date.now();
      if (inProgress || now - lastAttemptAt < DEBOUNCE_MS) return;
      inProgress = true;
      lastAttemptAt = now;
      try {
        await syncKaching(code);
        const cart = window.kachingCartApi?.getCartData?.();
        const applied = hasDiscount(cart);
        if (applied) emitCartUpdated();
      } finally {
        inProgress = false;
        safeSet(sessionStorage, ATTEMPT_KEY, attemptKey);
      }
    };
  
    const maybeApply = (cartData) => {
      if (!isAbraActive()) return;
      const code = getDiscountCode();
      if (!code) return;
  
      const cartToken = cartData?.token || window.kachingCartApi?.getCartData?.()?.token || 'no-token';
      const itemCount = cartData?.item_count ?? cartData?.items?.length ?? 0;
      const attemptKey = `${code.toUpperCase()}|${cartToken}|${itemCount}`;
      if (safeGet(sessionStorage, ATTEMPT_KEY) === attemptKey) return;
  
      apply(code, attemptKey);
    };
  
    const originalFetch = window.fetch;
    window.fetch = function (...args) {
      const url = (typeof args[0] === 'string' ? args[0] : args[0]?.url) || '';
      return originalFetch.apply(this, args).then(async (res) => {
        if (url.includes('_abraignore')) return res;
        try {
          const clone = res.clone();
          if (url.includes('cart/add')) maybeApply(await clone.json());
          else if ((url.includes('/cart.js') || url.includes('/cart?')) && !url.includes('/cart/update')) {
            const data = safeJson(await clone.text());
            if (data?.items) maybeApply(data);
          }
        } catch (e) {}
        return res;
      });
    };
  
    if (isAbraActive()) maybeApply(window.kachingCartApi?.getCartData?.() || {});
  
  })();
  
